import classNames from "@casino/external/classNames";
import type { ComponentProps } from "react";

const Container: FC<ComponentProps<"div">> = ({ className, ...props }) => (
  <div
    className={classNames("overflow-hidden max-h-[18.75rem]", className)}
    {...props}
  />
);

export default Container;
